<template>
  <div>
    <ReactWrapper :props="{ partnerInfo }" :react-component="reactComponent" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ReactWrapper from "../util/ReactWrapper.vue";
import { PartnerOverlayProvider } from "@iloq/partner-program/components/partner-overlay/partner-overlay-provider";
import { mapState } from "vuex";
import { IRootState } from "@iloq/shared/IRootState";

export default defineComponent({
  name: "TopNavPartnerOverlayConnector",
  components: {
    ReactWrapper,
  },
  data: function () {
    return {
      reactComponent: PartnerOverlayProvider,
    };
  },
  computed: {
    ...mapState({
      partnerInfo: (state: unknown) => (state as IRootState).partnerInfo!.partnerInfo,
    }),
  },
  watch: {
    partnerInfo: {
      deep: true,
      handler() {
        this.$forceUpdate();
      },
    },
  },
});
</script>
